export default Object.freeze({
  WG: 0,
  SSH: 1,
  SSH_REV: 2,
});
